export const SHOW_SPINNER = "spinner/SHOW_SPINNER";
export const HIDE_SPINNER = "spinner/HIDE_SPINNER";

export const ShowSpinner = () => {
    return { type: SHOW_SPINNER }
}
export const HideSpinner = () => {
    return { type: HIDE_SPINNER }
}